import React from 'react';
import { Button } from 'reactstrap';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';
import OrderPickups from './OrderPickups';
import RunPickupEditView from '../Pickups/RunPickupEditView';
import store from '../../store';
import {runRequestConfirmation, loadRun, loadProjectedRunFields} from "../../actions/runActions";
import { mustBeArray } from '../../utils/lib';

class RunEditView extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.onEditFieldChange = this.onEditFieldChange.bind(this);
    this.handleSmsRequestConfirmation = this.handleSmsRequestConfirmation.bind(this);
    this.state = {run: props.run, canSave: true, editingPickups: false, editingOrder: false};
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if(this.state.run && this.props.run && this.state.run.id !== this.props.run.id){      
      this.setState({run: this.props.run});
    }    
  }

  UNSAFE_componentWillReceiveProps(newprops){
    if(mustBeArray(newprops.run && newprops.run.pickups).length !== mustBeArray(this.props.run && this.props.run.pickups).length){
      this.setState({run: newprops.run});
    }
  }

  componentDidMount() {
    this.setState({run: this.props.run});
    store.dispatch(loadRun(this.props.run && this.props.run.id, null, null, false, false));
  }

  onEditFieldChange(e){
    let run = {...this.state.run};
    run[e.target.name] = e.target.value;
    this.setState({run});
  }

  handleSmsRequestConfirmation = runId => {
    store.dispatch(runRequestConfirmation(runId));
    this.props.clearEditView();
  }

  render(){
    let { drivers, trucks, handleViewMode, onFinishEdit, onDeleteRun, isAdmin, isEditView } = this.props;
    let { run } = this.state;
    return (
      <div className="card-block">
        <h4 className="card-subtitle">{run.regionsVisited}</h4>
        <div>&nbsp;</div>
        <div className="form-horizontal">
          <div className="form-group row">
            <label className="col-md-1 form-control-label" htmlFor="driverId">Driver</label>
            <div className="col-md-6">
              <select className="form-control custom-select"
                      value={run.driverId}
                      onChange={this.onEditFieldChange}
                      name="driverId">
                { drivers.items.map(d => (<option value={d.id} key={d.id}>{d.fullName}</option>)) }
              </select>
            </div>
          </div>
          <div className="form-group row">
            <label className="col-md-1 form-control-label" htmlFor="truckId">Truck</label>
            <div className="col-md-6">
              <select className="form-control custom-select"
                      value={run.truckId}
                      onChange={this.onEditFieldChange}
                      name="truckId">
                { trucks.items.filter(x => !x.isInactive).map(d => (<option value={d.id} key={d.id}>{d.name}</option>)) }
              </select>
            </div>
          </div>
          <div className="form-group row">
            <label className="col-md-1 form-control-label" htmlFor="select">Run date</label>
            <div className="col-md-6">
              <DatePicker
                onChange={(val) => this.onEditFieldChange({target: {name: 'timeStart', value: val.format('YYYY-MM-DD')}})}
                className="form-control"
                value={moment(run.timeStart).format('YYYY-MM-DD')}
                openToDate={moment(run.timeStart)}
                placeholderText="Run date"
                locale="en-au"
                name="timeStart"
                readOnly={false}
              />
            </div>
          </div>

          <div className="form-group row">
            <div className="offset-md-1 col-md-11">
              {!this.state.editingPickups && <OrderPickups
                run={run}
                style={{float: 'left', marginRight: '10px'}}
                onEnterReOrderRun={() => this.setState({canSave: false, editingOrder: true})}
                onLeaveReOrderRun={() => this.setState({canSave: true, editingOrder: false})}
                onFinishOrderRun={(run) => {
                  this.setState({run, canSave:true, editingOrder: false});
                }}
                isEditView={isEditView}
                loadProjectedRunFields={({runId}) => store.dispatch(loadProjectedRunFields({runId}))}
              />}
            </div>
          </div>
          {this.state.canSave && <div className="form-group row">
            <div className="col-md-6 offset-md-1">
              <Button color="primary" onClick={() => {
                onFinishEdit(run);
              }}><i className="fa fa-save" />&nbsp;&nbsp;Save run</Button>&nbsp;
              { (!run.isBaseCheckedIn && run.pickupsComplete == 0) &&
              <Button color="danger" onClick={() => {
                onDeleteRun(run.id);
              }}><i className="fa fa-trash" /></Button>}
              &nbsp;
              <Button color="secondary" onClick={() => handleViewMode('edit', false)}><i className="fa fa-mail-reply" /></Button>
            </div>
          </div>}

          { run.smsEnabled && isAdmin && run.hasSmsLocations && <div className="form-group row">
            <div className="col-md-6 offset-1">
              <button className="btn btn-danger" onClick={() => this.handleSmsRequestConfirmation(run.id)}>Request SMS confirmation</button>
            </div>
          </div> }
        </div>
      </div>);
  }
}

export default RunEditView;